
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";
import CustomersList from "@/components/CustomersList";
import DateRangeSelector, { DateRange } from "@/components/DateRangeSelector";
import { startOfMonth, endOfMonth } from "date-fns";

const Customers = () => {
  const { user, isLoading } = useAuth();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [dateRange, setDateRange] = useState<DateRange>(() => {
    const today = new Date();
    return {
      from: startOfMonth(today),
      to: endOfMonth(today),
    };
  });

  // If still loading, show nothing to prevent flashing
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>;
  }

  // If not authenticated, redirect to auth page
  if (!user) {
    return <Navigate to="/auth?tab=signin" />;
  }

  const handleDateRangeChange = (newRange: DateRange) => {
    setDateRange(newRange);
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Customers</h1>
        <p className="text-muted-foreground mt-2">
          View and manage your customer information
        </p>
      </div>
      
      <div className="mb-6">
        <DateRangeSelector onRangeChange={handleDateRangeChange} />
      </div>
      
      <CustomersList 
        refreshTrigger={refreshTrigger}
        dateRange={dateRange}
      />
    </div>
  );
};

export default Customers;
